import NoData from 'global/components/alerts/NoData';
import { MiniSwiper } from 'global/components/swipers/MiniSwiper';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { _matchLsTypes } from 'projectSpecific/sports/cnr/reducers/SportsDataReducer';
import { useContext, useMemo } from 'react';
import { SectionStandingz } from './SectionStandingz';

const LevelSectionStandings = ({
  _matchKey_page,
  _standingType,
  _teamKey_page,
  _teamsFavs,
  forOverview,
  forPlayoff,
  noData,
  playoffLevel,
  selectedLevelKey,
  showPlayoffPicture,
}) => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { sportsShowType, matches_info, teams_info } = sportsSeason_state ?? {};
  const { teams } = teams_info ?? {}
  const { matches_groupInfo } = matches_info ?? {}
  const { levelKeys } = matches_groupInfo ?? {}

  // get the relevant level keys
  const _levelKeyz = _.difference(levelKeys, [_matchLsTypes.Non, _matchLsTypes.nonDistrict, _matchLsTypes.nonSection])

  // all the matches
  const { matches } = matches_info ?? {}

  const { _levelKeys, _matchSections } = useMemo(() => {

    if (_matchKey_page) {
      return { ...getMatchLevelKeys(matches, _matchKey_page) }
    } else {
      return { _levelKeys: _levelKeyz }
    }

  }, [levelKeys, _matchKey_page])

  const ss = (lk, _matchSections) => <SectionStandingz
    levelKey={lk}
    matchSections={_matchSections}
    _teamsFavs={_teamsFavs}
    teamKey={_teamKey_page}
    matchKey={_matchKey_page}
  />

  /**
   * 
   * @param {object} lks 
   * @param {object} _matchSections 
   * @returns a group of SectionStandingz with captions
   */
  const levelSectionsContent = (lks, _matchSections) => {
    if (!lks) return null;
    return _.map(lks, lk => (
      {
        caption: lk,
        content: ss(lk, _matchSections)
      }
    ))
  };

  const teamStandings = useMemo(() => {
    if (_teamKey_page && forOverview) {
      return <SectionStandingz
        levelKey={selectedLevelKey}
        _teamsFavs={_teamsFavs}
        teamKey={_teamKey_page}
        matchKey={_matchKey_page}
        forOverview={forOverview}
      />
    }
  }, [_teamKey_page])

  const leagueStandings = useMemo(() => {

    // if no level keys return
    if (!_levelKeys) { return <div>NLKS</div>; }

    // if this is for a playoff, show that
    if (showPlayoffPicture || playoffLevel) {
      return <SectionStandingz levelKey={playoffLevel} _teamsFavs={_teamsFavs} />
    }

    // if this is a match page, show the standings for the 2 teams in the match
    if (_matchKey_page) {
      return <MiniSwiper
        includeButtons={false}
        swipeItems={levelSectionsContent(_levelKeys, _matchSections)}
        showButtons={false}
      />
    }

    if (_teamKey_page && teams?.[_teamKey_page]?.levels) {
      return <MiniSwiper
        includeButtons={false}
        swipeItems={levelSectionsContent([teams?.[_teamKey_page]?.levels], _matchSections)}
        showButtons={false}
      />
    }

    if (noData) {
      return <NoData fullCaption={'No Standings'} />;
    }

    // show the standing for each of the level keys in a swiper (normal)
    return (
      <MiniSwiper
        includeButtons={true}
        swipeItems={levelSectionsContent(_levelKeys)}
        showButtons={true}
      />
    );
  }, [
    sportsShowType,
    _standingType,
    forOverview,
    playoffLevel,
    showPlayoffPicture,
    selectedLevelKey,
    _matchKey_page,
    _levelKeys,
    _teamKey_page,
    teams,
  ]);

  return forOverview ? teamStandings : leagueStandings;

};

export default LevelSectionStandings;

const getMatchLevelKeys = (matches, _matchKey_page) => {
  const _match = matches?.[_matchKey_page]
  const { away, home } = _match ?? {}
  const { levels: levels_away, sections: sections_away } = away ?? {}
  const { levels: levels_home, sections: sections_home } = home ?? {}
  const _matchLevelKeys = [levels_away]
  const _matchSections = [`${levels_away}-${sections_away}`]
  if (levels_home !== levels_away && !_.includes(_matchLevelKeys, levels_home)) { _matchLevelKeys.push(levels_home) }
  if (sections_home !== sections_away) { _matchSections.push(`${levels_home}-${sections_home}`) }
  return { _levelKeys: _.sortBy(_matchLevelKeys).reverse(), _matchSections }
}